import { useState, useEffect } from "react";
import { fetchData, renderPreText } from "./Helpers";

export default function PricingServices() {
  const [fullData, setFullData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData("streaming_pricing_services").then((res) => {
      setFullData(res);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById('grid');
    let columns = [
      { name: 'Characteristic', field: 'characteristic', width: 2, scalable: true, binding: renderPreText},
      { name: 'Pricing Snapshot Service', field: 'pricingSnapshotService', width: 3, scalable: true, binding: renderPreText},
      { name: 'Pricing Streaming Service', field: 'pricingStreamingService', width: 3, scalable: true, binding: renderPreText},
      { name: 'Pricing Streaming Optimized Service', field: 'pricingStreamingOptimizedService', width: 3, scalable: true, binding: renderPreText}
    ];

    grid.config = {
      rowHeight: 120,
      headerRowHeight: 60,
      columns: columns,
      dataModel: {
        data: fullData,
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
            colIndex: 0, // Column index`
            sortOrder: "a"
        }
      }
    };
  }, [fullData]);

  return (
    <div className="main-div">
        <ef-loader class="loader" hidden={!loading}></ef-loader>
        <efx-grid id="grid" className="entity-grid"></efx-grid>
        <p className="disclaimer_p"><b>Note:</b> Historical pricing cannot be ordered individually, it is part of pricing service. Clients have to sign for a quotes/pricing package  to get access to historical pricing. </p>
        <p className="disclaimer_p">There are 3 types of historical data that we offer:</p>
        <ul className="disclaimer_ul">
          <li><b>Intraday:</b> time intervals smaller than 1 day (min, 5mins, 10mins, 30, 60mins/1h)</li>
          <li><b>Interday:</b> time intervals are daily , weekly , monthly, quarterly and yearly	</li>
          <li><b>Time & Sales:</b> is the tick data, this is an add-on. Clients have to subscribe to it in addition to any Pricing Snapshot package.</li>
        </ul>
        <p className="disclaimer_p">The link between the pricing QoS and the Historical data</p>
        <ul className="disclaimer_ul">
          <li>If a client signs for an EoD quotes packages: he only has access to Interday Historical Pricing.</li>
          <li>If a client signs for a quotes package with delayed exchanges: he has access to Interday and Intraday Historical Pricing for the delayed exchanges.</li>
          <li>If a client signs for a quotes package with RT exchanges: he has access to Interday and Intraday Historical Pricing, optionally he can have access to T&S.</li>
        </ul>
    </div>
  );
}